import React from 'react';
import './NotificationBadge.css';

/**
 * NotificationBadge - A small red circle badge showing notification count
 * 
 * Props:
 * - count: number - The notification count to display
 * - size: 'small' | 'medium' | 'large' - Badge size (default: 'medium')
 * - showZero: boolean - Whether to show badge when count is 0 (default: false)
 * - isIndicator: boolean - Show as indicator (!) instead of count (default: false)
 * - className: string - Additional CSS classes
 */
function NotificationBadge({ 
    count = 0, 
    size = 'medium', 
    showZero = false,
    isIndicator = false,
    className = ''
}) {
    // Don't render if count is 0 and showZero is false
    if (count === 0 && !showZero && !isIndicator) {
        return null;
    }

    // For indicator mode, only show if there's something to indicate
    if (isIndicator && count === 0) {
        return null;
    }

    const displayText = isIndicator ? '!' : (count > 99 ? '99+' : count);

    return (
        <span 
            className={`notification-badge notification-badge-${size} ${isIndicator ? 'notification-badge-indicator' : ''} ${className}`}
            aria-label={isIndicator ? 'Has notification' : `${count} notifications`}
        >
            {displayText}
        </span>
    );
}

export default NotificationBadge;

